var render = function render(){var _vm=this,_c=_vm._self._c;return _c('y-layout-body-menu',{attrs:{"aside-width":"8rem","menu":[
  {title:'基础配置',path:'/card/plugin/principal/rule'},
  {title:'主理人管理',path:'/card/plugin/principal/user'},
  {title:'主理人订单',path:'/card/plugin/principal/order'},
]}},[_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }